import { useEffect, useState } from "react"
import { deviceconfigcrud } from "../services/configurationServices";

export const useDeviceType = () => {
    const [deviceType, setDeviceType] = useState([])
    const [deviceTypeOptions, setDeviceTypeOptions] = useState([]);
    const [panelDeviceTypeOptions, setPanelDeviceTypeOptions] = useState([]);

    useEffect(() => {
        getDeviceType();
    }, []);

    const getDeviceType = (id) => {
        try {
            let obj = {
                "type": "devicetype"
            }
            if(id){
                obj.parameters = {
                    "InterfaceTypeID": id
                }
            }
            deviceconfigcrud(obj).then((resp) => {
                if (resp.Status == "success") {
                    if (resp.Data != null) {
                        setDeviceType(resp.Data)
                        let arr = resp.Data.map((item) => ({
                            value: item.DeviceTypeID,
                            label: item.DeviceType
                        }))
                        setDeviceTypeOptions(arr);
                    }
                }
            })
        } catch (error) {
            console.log(error)
        }
    }

    const getDataAfterInterface = (id) => {
        let ans = []
        try {
            let obj = {
                "type": "devicetype"
            }
            if(id){
                obj.parameters = {
                    "InterfaceTypeID": id
                }
            }
            deviceconfigcrud(obj).then((resp) => {
                if (resp.Status == "success") {
                    if (resp.Data != null) {
                        // setDeviceType(resp.Data)
                        let arr = resp.Data.map((item) => ({
                            value: item.DeviceTypeID,
                            label: item.DeviceType
                        }))
                        setPanelDeviceTypeOptions(arr);
                    }
                }
            })
        } catch (error) {
            console.log(error)
        }

        return ans;
    }

    return { deviceType, deviceTypeOptions, panelDeviceTypeOptions, setDeviceType, setDeviceTypeOptions, getDeviceType, getDataAfterInterface }
}